import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const RepairIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M42.4997 127.46H33.0123C27.9124 127.46 23.75 123.298 23.75 118.198V97.461H139.998V118.198C139.998 123.298 135.836 127.46 130.736 127.46H72.499"
                stroke={color}
                strokeWidth="6"
                strokeLinejoin="round"
            />
            <path
                d="M20 45.4122V66.5995C20 69.1495 22.0625 71.212 24.6124 71.212H45.3496C47.8996 71.212 49.962 69.1495 49.962 66.5995V60.862C49.962 58.312 52.0245 56.2495 54.5745 56.2495H96.9485C102.048 56.2495 106.211 60.412 106.211 65.512V97.499H139.96V45.4497C139.96 36.9374 133.06 30 124.51 30H35.4498C26.9374 30 20 36.8999 20 45.4497V45.4122Z"
                stroke={color}
                strokeWidth="6"
                strokeLinejoin="round"
            />
            <path
                d="M140 48.7109H123.125C120.019 48.7109 117.5 51.2295 117.5 54.336C117.5 57.4425 120.019 59.9605 123.125 59.9605H140"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path d="M34.9951 71.211V82.4605" stroke={color} strokeWidth="6" strokeLinejoin="round" />
        </svg>
    );
};
